import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

declare var gtag;

@Component({
  selector: 'app-dialog-qrcode-link',
  templateUrl: './dialog-qrcode-link.component.html',
  styleUrls: ['./dialog-qrcode-link.component.scss'],
  standalone: false,
})
export class DialogQRCodeLinkComponent implements OnInit {
  translate = inject(TranslateService);

  private eventChange$: Observable<boolean>;
  private _observer: Observer<boolean>;
  showDialog: boolean = false;
  caption: string;
  messangerUrl: string;
  iconUrl: string;

  elementType: 'url' | 'canvas' | 'img' = 'url';

  constructor() {
    this.eventChange$ = new Observable<boolean>(observer => (this._observer = observer));
  }

  ngOnInit(): void {}

  execute(caption: string, messangerUrl: string, iconUrl: string): Observable<boolean> {
    this.caption = caption;
    this.messangerUrl = messangerUrl;
    this.iconUrl = iconUrl;
    this.showDialog = true;

    gtag('event', 'chatbot_popup_is_shown');

    return this.eventChange$;
  }

  onCancel() {
    this._observer.next(false);
    this.showDialog = false;
  }
}
